import React from "react";

//componets
import Header from "../Components/Header/index";
import Footer from "../Components/Footer";
import BookingDetails from "../Components/Booking/BookingDetails";

function Booking() {
  return (
    <>
      <Header />
      <BookingDetails />
      <Footer />
    </>
  );
}

export default Booking;
